var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.displayCount)?_c('div',{staticClass:"opc-plan__bought-license"},[_c('span',[_vm._v(_vm._s(_vm.$t('billing.prorated.cur_users', [_vm.displayCount, _vm.unit] )))])]):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }